export const typography = {
  fontFamily: [
    "Roboto",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Arial",
    "sans-serif",
  ].join(","),
};

// Acento monoespaciado restringido: precios, IDs, timestamps.
// No es una clave estándar de MUI, se expone vía theme.custom.fontMono
// y se aplica explícitamente donde corresponda (no globalmente).
export const fontMono = [
  '"JetBrains Mono"',
  "ui-monospace",
  "Consolas",
  "monospace",
].join(",");
